import { PRIVACY_URL, TERMS_URL } from '../lib/legal';

/**
 * Formulation unique de l'acceptation, partagée par tous les parcours
 * d'inscription du portail — la même que SEmplyApp : les CGU s'ACCEPTENT
 * (engagement contractuel), la politique de confidentialité se porte à
 * connaissance (information RGPD), ce ne sont pas deux consentements.
 */
export function TermsLabel() {
  return (
    <span>
      J'accepte les{' '}
      <a href={TERMS_URL} target="_blank" rel="noreferrer">
        conditions générales d'utilisation et de vente
      </a>{' '}
      et j'ai pris connaissance de la{' '}
      <a href={PRIVACY_URL} target="_blank" rel="noreferrer">
        politique de confidentialité
      </a>
      .
    </span>
  );
}
